import React from 'react';
import { startCase } from 'lodash';
import classNames from 'classnames';

import { Counter } from '@/components';
import { NOT_DEFINED } from '@/constants';
import { useFeaturedFlag } from '@/hooks';

import {
  ProductActionFavorite,
  ProductBadgeContainer,
  ProductCategory,
  ProductIconShopping,
  ProductImage,
  ProductInfo,
  ProductInfoPack,
  ProductLinkWrapper,
  ProductName,
  ProductPrice,
  ProductVariants,
} from '../Product.components';

import { ProductVariationProps } from '../Product';
import { useProductContext } from '../context';

import style from '../product.module.scss';
import styleVariation from '../variations/ProductCardDefault.module.scss';

const ProductCardDefault: React.FC<ProductVariationProps> = ({
  className,
  analyticsListName,
}) => {
  const {
    product,
    isSpecial,
    quantity,
    variants,
    weightVariant,
    compoundList,
  } = useProductContext();
  const { isTaxAppliedMessage } = useFeaturedFlag();

  return (
    <ProductLinkWrapper
      analyticsListName={analyticsListName}
      className={classNames(style.product, className)}
      product={product}
    >
      <ProductBadgeContainer
        className={styleVariation.product__badges}
        product={product}
        weightVariant={weightVariant}
      />
      <ProductImage product={product} />
      <div className={style.product__body}>
        <div className={style.product__name_container}>
          <ProductInfo
            className={style.brand}
            info={product.brand_name || NOT_DEFINED}
            type="default"
          />
          <ProductName name={product?.name || NOT_DEFINED} />
        </div>
        <div className={style.info__brand_category}>
          <ProductInfo
            className={style.category}
            info={
              startCase(product?.subcategory as string) ||
              startCase(NOT_DEFINED)
            }
            type="default"
          />
          <ProductCategory
            className={style.product__only_category}
            info={product?.flower_type!}
            type="filled"
          />
        </div>
        <ProductInfoPack compoundList={compoundList} />
        <div className={style.info__price_variation}>
          <ProductPrice
            isOverflow={variants?.length === 1}
            isSpecial={isSpecial}
            weightVariant={weightVariant}
          />
          <ProductVariants />
          {isTaxAppliedMessage && (
            <span className={style.tax_message}>(tax. included)</span>
          )}
        </div>
        <div className={style.product__actions_footer}>
          <Counter
            className={classNames(
              style.actions__counter,
              styleVariation.actions__counter_mobile,
            )}
            onCard
            product={product}
            selectedWeightVariant={weightVariant}
          />
          <div
            className={classNames(
              style.actions__body,
              styleVariation.action__body_mobile,
            )}
          >
            <ProductIconShopping quantity={quantity} />
            <ProductActionFavorite product={product} />
          </div>
        </div>
      </div>
    </ProductLinkWrapper>
  );
};

export { ProductCardDefault };
